<div class="side-bar">
  <ng-container *ngIf="service&&service.id">
    <button class="btn btn-outline-danger btn-sm"
            (click)="deleteService()"
            appSpinner
            [isLoading]="isLoading"
            [disabled]="isLoading"
            *hasPermission="['services.delete']">
      <ezy-icons src="assets/icons/trash-alt.svg"
                 class="text-danger"></ezy-icons>
      Delete Service
    </button>
  </ng-container>
  <div class="pb-4">
    <div class="pb-2 title d-flex justify-content-between">
      <div>Image/Photo</div>
      <a class='text-primary text-decoration-underline'
         appSpinner
         [isLoading]="uploadingImage"
         (click)="image.click()">Select Photo</a>
      <input type="file"
             class="form-control-file d-none"
             id="image"
             #image
             [disabled]="uploadingImage"
             name="image"
             (change)="previewImage($event)"
             accept="image/svg">
    </div>
    <div class="img-container">
      <img [src]="iconUrl"
           style="width:100%;height: 100%;"
           alt="Service Image">
    </div>
  </div>
  <div class="card">
    <div class="custom-control custom-checkbox">
      <input type="checkbox"
             [formControl]="formControls.published"
             class="custom-control-input"
             id="publish">
      <label class="custom-control-label"
             for="publish">Publish Service</label>
    </div>
    <div>
      <button class="btn btn-primary w-100"
              (click)="onSubmit()"
              appSpinner
              [isLoading]="isLoading"
              [disabled]="!isValidForm||isLoading"
              *hasPermission="['services.edit', 'services.create']"
              hasPermissionOp="OR">
        Save Changes
      </button>
    </div>
  </div>
</div>
